<template>
  <div class="bjcx">
    <h3 class="xy-title"><b>报价查询</b></h3>
    <el-form ref="priceForm" :model="form" :rules="rules" label-width="80px" size="mini" @submit.native.prevent="handleSubmit">
      <el-form-item label="目的地">
        <el-input v-model="form.country" size="mini" placeholder="请输入目的地"></el-input>
      </el-form-item>
      <el-form-item label="实重">
        <el-input v-model="form.rweight" size="mini" placeholder="请输入实重">
          <template slot="suffix">KG</template>
        </el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="form.goodstype" size="mini" placeholder="请选择类型">
          <el-option label="文件" value="DOC"></el-option>
          <el-option label="包裹" value="WPX"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="体积重">
        <el-row :gutter="10">
          <el-col :span="7">
            <el-input v-model="form.len" size="mini" placeholder="长"></el-input>
          </el-col>
          <el-col class="line" :span="1">* </el-col>
          <el-col :span="7">
            <el-input v-model="form.width" size="mini" placeholder="宽"></el-input>
          </el-col>
          <el-col class="line" :span="1">* </el-col>
          <el-col :span="6">
            <el-input v-model="form.height" size="mini" placeholder="高"></el-input>
          </el-col>
          <el-col class="line" :span="1">CM</el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" native-type="submit" icon="el-icon-search" style="margin-top: 10px;">开始计算</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        country: '',
        rweight: '',
        goodstype: 'WPX',
        len: '',
        width: '',
        height: '',
      },
      rules: {
        country: [
          { required: true, message: '请输入目的地', trigger: 'blur' },
        ],
        rweight: [
          { required: true, message: '请输入实重', trigger: 'blur' },
        ],
        len: [
          { required: true, message: '请输入长', trigger: 'blur' },
        ],
        width: [
          { required: true, message: '请输入宽', trigger: 'blur' },
        ],
        height: [
          { required: true, message: '请输入高', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    handleSubmit() {
      // this.$refs.priceForm.validate((valid) => {
      //   if (valid) {
          // 使用 URLSearchParams 将表单数据转换为查询字符串
          const formData = new URLSearchParams();
          formData.append('country', this.form.country);
          formData.append('rweight', this.form.rweight);
          formData.append('goodstype', this.form.goodstype);
          formData.append('len', this.form.len);
          formData.append('width', this.form.width);
          formData.append('height', this.form.height);

          // 构建目标 URL
          const url = `https://xy56.kingtrans.cn/WebPrice?${formData.toString()}`;

          // 跳转到目标页面
          window.open(url, '_blank');
        // } else {
        //   console.log('表单验证失败');
        //   return false;
        // }
      // });
    },
  },
};
</script>


<style lang="scss" scoped>
.bjcx {
  /* height: 200px; */
  float: left;
  /* margin: 0 40px; */
}
.el-form-item {
  margin-bottom: 20px;
}
.el-button {
  float: right;
}
</style>



// WEBPACK FOOTER //
// xy-price-form.vue?37b1cd74